export const anticipationRule = state => state.anticipationRule;
export const anticipationTax = state => state.anticipationTax;
export const accountTaxes = state => state.accountTaxes;
export const accountTaxBrands = state => state.accountTaxBrands;
export const accountTaxSelectedBrand = state => state.accountTaxSelectedBrand;
export const accountPayers = state => state.accountPayers;
export const accountLends = state => state.accountLends;
export const anticipationsAvailable = state => state.anticipationsAvailable;
export const anticipationsAvailableCount = state => state.anticipationsAvailableCount;
export const balance = state => state.balance;
export const currentTax = state => state.currentTax;
export const selectedAnticipations = state => state.selectedAnticipations;
export const selectedAnticipationsAmount = state => state.selectedAnticipationsAmount;
export const anticipationsAvailablePage = state => state.anticipationsAvailablePage;
export const anticipationsAvailableLimit = state => state.anticipationsAvailableLimit;
export const isLoad = state => state.isLoad;
export const account = state => state.account;
export const logoLink = state => state.logoLink;
export const favicon = state => state.favicon;
export const partnerUrl = state => state.partnerUrl;
export const color = state => state.color;
export const partnerName = state => state.partnerName;
export const partner = state => state.partner;
export const notifications = state => state.notifications;
export const notificationsVisible = state => state.notificationsVisible;
export const newLend = state => state.newLend;
export const newLendStatus = state => state.newLendStatus;
export const newLendError = state => state.newLendError;
export const errors = state => state.errors;
export const showError = state => state.showError;
export const showSuccess = state => state.showSuccess;
export const activeNew = state => state.activeNew;
export const isBillPaymentEnabled = state => state.isBillPaymentEnabled;
export const isInvoicePaymentEnabled = state => state.isInvoicePaymentEnabled;
export const isDarfPaymentEnabled = state => state.isDarfPaymentEnabled;
export const isLinkPaymentEnabled = state => state.isLinkPaymentEnabled;
export const isManualSaleEnabled = state => state.isManualSaleEnabled;
export const isRecurringPaymentEnabled = state => state.isRecurringPaymentEnabled;
export const isRechargeEnabled = state => state.isRechargeEnabled;
export const loading = state => state.loading;
export const userId = state => state.account.id || state.account.user_id;

/* forms */
export const showLogoForm = state => state.showLogoForm;
export const showFaviconForm = state => state.showFaviconForm;
export const showColorForm = state => state.showColorForm;
export const showForm = state => state.showForm;

/* status messages */
export const successStatus = state => state.successStatus;
export const errorStatus = state => state.errorStatus;
export const successMessage = state => state.successMessage;
export const errorMessage = state => state.errorMessage;

/* client-portal permissions (multiusuário) */
export const capabilities = state => state.account && state.account.capabilities;
export const isOwner = state => !!(state.account && state.account.is_owner);
// Returns a predicate. Owner can do everything; while capabilities haven't
// loaded yet (undefined) we fail-open so nothing flickers/locks during boot.
export const can = (state, getters) => capability => {
  if (getters.isOwner) return true;
  const caps = getters.capabilities;
  if (!Array.isArray(caps)) return true;
  return caps.includes(capability);
};

export const anticipationsFilter = state => {
  const filters = {
    page: state.anticipationsAvailablePage,
    limit: state.anticipationsAvailableLimit
  };
  return filters;
};
